import React, {
  ReactNode,
  useState,
} from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { SpeedDial as MaterialSpeedDial } from '@mui/material';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import styleVariables from 'shared/styleVariables';

interface Props {
  children: ReactNode;
  label: string;
}

const SpeedDial: React.FC<Props> = ({ children, label }: Props) => {
  const theme = useTheme();
  const showSmall = useMediaQuery(theme.breakpoints.down('xl'));
  const [speedDialOpen, setSpeedDialOpen] = useState(false);

  const handleClose = () => {
    setSpeedDialOpen(false);
  };

  const handleClick = () => {
    setSpeedDialOpen(!speedDialOpen);
  };

  return (
    <MaterialSpeedDial
      ariaLabel={label}
      direction="down"
      icon={<SpeedDialIcon />}
      onClose={handleClose}
      onClick={handleClick}
      open={speedDialOpen}
      FabProps={{
        size: showSmall ? 'small' : 'medium',
        sx: {
          backgroundColor: styleVariables.textPrimary,
          '&:hover': { backgroundColor: 'action.active' },
        },
      }}
    >
      {children}
    </MaterialSpeedDial>
  );
};

export default SpeedDial;
